import breakpoints from '../../../theme/breakpoints'
import theme from '../../../theme/news12'
import redesignedTheme from '../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css`
  .card {
    padding-top: 25px;
    position: relative;
  }

  .options {
    position: absolute;
    right: 20px;
    top: 0;
    cursor: pointer;
    background-color: ${theme.colors.white};
    border: none;
    width: 20px;
    height: 20px;
    padding: 0;
  }

  .options::after {
    content: '•••';
    font-weight: 600;
    letter-spacing: 2px;
    color: ${theme.colors.lightGray5};
  }

  .image-container {
    position: relative;
  }

  .play-video {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 4px;
    left: 4px;
    width: 48px;
    height: 18px;
    background: ${redesignedTheme.colors.lightBlue};
    border-radius: 25px;
  }

  .timestamp {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 14px;
    font-weight: 500;
    color: ${theme.colors.lightGray5};
  }
  
  .duration-time {
    font-family: 'Graphik';
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 100%;
    color: ${theme.colors.white};
    line-height: 100%;
    margin-top: 1px;
    max-height: 10px;
    -webkit-text-size-adjust: none;
  }
  
  .duration-time span {
    display: inline-block;
    height: 100%;
  }
  
  .play-icon {
    height: 8px;
    width: 8px;
    padding-right: 1px;
    margin-top: 0;
  }

  .card-title {
    font-size: 16px;
    font-weight: 500;
    color: ${redesignedTheme.colors.mineShaft};
    line-height: 21px;
    font-family: 'Graphik';
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .options {
      right: 0
    }
  }
`
